(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  /* Show one gallery image and mark its thumbnail */
  function pdpShowMedia(pdp, id) {
    var media = pdp.querySelector('.pdp__stage [data-media-id="' + id + '"]');
    if (!media) return;
    pdp.querySelectorAll('.pdp__stage .pdp-media').forEach(function (m) {
      m.classList.toggle('is-active', m === media);
    });
    pdp.querySelectorAll('[data-thumb]').forEach(function (t) {
      var on = t.getAttribute('data-thumb') === String(id);
      t.classList.toggle('is-active', on);
      if (on) {
        t.setAttribute('aria-current', 'true');
        /* Scroll the strip sideways only, never the page */
        var strip = t.closest('.pdp__thumbs');
        var left = t.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft || left + t.offsetWidth > strip.scrollLeft + strip.clientWidth) {
          strip.scrollLeft = left;
        }
      } else {
        t.removeAttribute('aria-current');
      }
    });
  }

  document.querySelectorAll('[data-pdp]').forEach(function (pdp) {
    pdp.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        pdpShowMedia(pdp, btn.getAttribute('data-thumb'));
      });
    });
  });

  document.querySelectorAll('[data-pdp]').forEach(function (pdp) {
    var form = pdp.querySelector('[data-pdp-form]');
    if (!form) return;
    var root = pdp.parentNode;
    var variants = JSON.parse(root.querySelector('[data-pdp-variants]').textContent);
    var prices = JSON.parse(root.querySelector('[data-pdp-prices]').textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add]');
    var addText = form.querySelector('[data-add-text]');
    var isHat = !!pdp.querySelector('[data-bundle-panel]');
    var priceEl = pdp.querySelector('[data-price]');
    var colorName = pdp.querySelector('[data-color-name]');
    var optionInputs = form.querySelectorAll('[data-option-value]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Announce price and button-state changes to screen readers */
    if (priceEl) priceEl.setAttribute('aria-live', 'polite');
    if (addText) addText.setAttribute('aria-live', 'polite');
    var optionCount = form.querySelectorAll('.pdp-opt').length;
    var sizeFieldset = null;
    form.querySelectorAll('.pdp-opt').forEach(function (fs) {
      var lg = fs.querySelector('.pdp-opt__label');
      if (lg && /size/i.test(lg.textContent)) sizeFieldset = fs;
    });

    function selectedValues() {
      var vals = [];
      for (var i = 0; i < optionCount; i++) {
        var checked = form.querySelector('[data-option-value][data-index="' + i + '"]:checked');
        vals[i] = checked ? checked.value : null;
      }
      return vals;
    }

    function findVariant(vals) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      });
    }

    function update() {
      var vals = selectedValues();
      var variant = findVariant(vals);
      var missing = vals.indexOf(null);

      if (variant) {
        idInput.value = variant.id;
        if (prices[variant.id]) priceEl.textContent = prices[variant.id];
      }
      if (colorName) {
        var ci = 0;
        form.querySelectorAll('.pdp-opt').forEach(function (fs, idx) {
          if (fs.classList.contains('pdp-opt--color')) ci = idx;
        });
        if (vals[ci]) colorName.textContent = vals[ci];
      }

      if (missing !== -1) {
        addBtn.disabled = true;
        addText.textContent = sizeFieldset ? 'Select a size' : 'Select options';
      } else if (variant && variant.available) {
        addBtn.disabled = false;
        addText.textContent = addLabel(variant);
      } else {
        addBtn.disabled = true;
        addText.textContent = 'Sold out';
      }

      markUnavailable(vals);
    }

    /* Same plain label for every product; the bundle panel sells the deal */
    function addLabel() {
      return 'Add to cart';
    }

    function markUnavailable(vals) {
      if (!sizeFieldset) return;
      var sizeIdx = parseInt(sizeFieldset.getAttribute('data-option-index'), 10);
      sizeFieldset.querySelectorAll('[data-option-value]').forEach(function (input) {
        var trial = vals.slice();
        trial[sizeIdx] = input.value;
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) {
            return i === sizeIdx ? o === input.value : (vals[i] == null || o === vals[i]);
          });
        });
        var label = form.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !(match && match.available));
      });
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        update();
        showVariantMedia(findVariant(selectedValues()));
      });
    });

    /* Swap the big image to the chosen variant's photo */
    function showVariantMedia(variant) {
      if (!variant || !variant.featured_media) return;
      pdpShowMedia(pdp, variant.featured_media.id);
      var stage = pdp.querySelector('.pdp__stage');
      if (stage && stage.getBoundingClientRect().top < 0) {
        stage.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    }

    /* Pending state: stop double submits while the add-to-cart request navigates */
    form.addEventListener('submit', function (e) {
      if (isHat && window.WRBundle) {
        e.preventDefault();
        WRBundle.run(addBtn, function () { return WRBundle.add(idInput.value, 1); });
        return;
      }
      if (form.dataset.pending) {
        e.preventDefault();
        return;
      }
      form.dataset.pending = '1';
      addBtn.setAttribute('aria-busy', 'true');
      addText.textContent = 'Adding';
    });
    window.addEventListener('pageshow', function () {
      delete form.dataset.pending;
      addBtn.removeAttribute('aria-busy');
      update();
    });

    /* Keep the sticky column fully reachable: if it is taller than the
       screen, pin its bottom edge instead of its top */
    var info = pdp.querySelector('.pdp__info');
    function fitSticky() {
      if (!info || getComputedStyle(info).position !== 'sticky') return;
      info.style.top = Math.min(24, window.innerHeight - info.offsetHeight - 24) + 'px';
    }
    window.addEventListener('resize', fitSticky);
    document.addEventListener('wr:cart', function () { requestAnimationFrame(fitSticky); });
    fitSticky();

    update();
  });

  } catch(e) { console.error(e); }
})();
})();
